import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";
import { CreateModalStyled } from "./CreateStudentModal";
import { ListGroup } from "react-bootstrap";
import { Typography } from "@mui/material";
import { colors } from "../config/colors";
import {
  CREATE_USER_CONSTANTS,
  ADMIN_TYPE,
  REGEX_VALIDATIONS,
} from "../config/constants";
import { EyeOpenLogo, EyeHideLogo } from "../assets/icons";
import { SKIPLY_MERCHANT_ID } from "../utils/Config";

export const CreateUserModal = ({
  show,
  handleHide,
  handleSave,
  emailAddress,
  firstName,
  lastName,
  password,
  phoneNumber,
  role,
  handleChange,
  validated,
}) => {
  const [showPass, setShowPass] = useState(false);
  const [showConfirmMode, setShowConfirmMode] = useState(false);
  const [hasError, setIsError] = useState({});
  const merchantIdGlobal = localStorage.getItem("globalMerchantId");
  const isSuperAdmin =
    localStorage.getItem("role") === ADMIN_TYPE.SUPER_ADMIN &&
    merchantIdGlobal === SKIPLY_MERCHANT_ID;
  const UserDetailsInputList = [
    {
      label: "Email address",
      value: emailAddress,
      eventId: "emailAddress",
      isRequired: true,
      type: "email",
      regex: "alphaNumericWithSpecialChar",
      saveRegex: "email",
    },
    {
      label: "First name",
      value: firstName,
      eventId: "firstName",
      isRequired: true,
      type: "text",
      regex: "alphaWithSpace",
      saveRegex: "alphaWithSpace",
    },
    {
      label: "Last name",
      value: lastName,
      eventId: "lastName",
      isRequired: false,
      type: "text",
      regex: "alphaWithSpace",
      saveRegex: "alphaWithSpace",
    },
    {
      label: "Password",
      value: password,
      eventId: "password",
      isRequired: true,
      type: "password",
      regex: "alphaNumericWithSpecialChar",
      saveRegex: "password",
    },
    {
      label: "Phone number",
      value: phoneNumber,
      eventId: "phoneNumber",
      isRequired: true,
      type: "number",
      saveRegex: "phoneNumber",
    },
  ];

  const saveDetails = () => {
    const emptyElem = UserDetailsInputList.find(
      (item) => item.isRequired && !item.value
    );
    if (emptyElem) {
      setIsError({ [emptyElem.eventId]: `${emptyElem.label} is required` });
    } else if (!role) {
      setIsError({ role: "Role is required" });
    } else {
      setShowConfirmMode(true);
    }
  };
  const editDetails = () => setShowConfirmMode(false);
  const handleHideMenu = () => {
    setIsError(false);
    setShowConfirmMode(false);
    handleHide();
  };
  const handleSaveUser = () => {
    setShowConfirmMode(false);
    handleHide();
    handleSave();
  };

  const UserDetailsList = [
    { label: "Email address", value: emailAddress },
    { label: "First name", value: firstName },
    { label: "Last name", value: lastName },
    { label: "Password", value: password },
    { label: "Phone number", value: phoneNumber },
    { label: "Role", value: role },
  ];

  return (
    <CreateModalStyled
      show={show}
      onHide={handleHideMenu}
      dialogClassName="modal-width-half"
      aria-labelledby="example-custom-modal-styling-title"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="example-custom-modal-styling-title"
          className="modal-header-text"
        >
          {showConfirmMode
            ? CREATE_USER_CONSTANTS.CONFIRM_PAGE_HEADER
            : CREATE_USER_CONSTANTS.USER_PAGE_HEADER}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showConfirmMode ? (
          <Fragment>
            <div className="modal-confirmation">
              <ListGroup bsPrefix="modal-list-group">
                {UserDetailsList.map((item) => (
                  <ListGroup.Item
                    bsPrefix="modal-list-group-item"
                    key={item.label}
                  >
                    <Typography variant="h4" component="span">
                      {item.label}
                    </Typography>
                    <Typography
                      variant="h4"
                      component="span"
                      sx={{ color: colors.custom, fontSize: "18px" }}
                    >
                      {item.value}
                    </Typography>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
            <div className="modal-button-container">
              <Button
                className="edit-button-btn"
                onClick={editDetails}
                style={{ width: "45%" }}
              >
                {CREATE_USER_CONSTANTS.EDIT_BUTTON}
              </Button>
              <Button
                className="create-button-btn"
                onClick={handleSaveUser}
                style={{ width: "45%" }}
              >
                {CREATE_USER_CONSTANTS.CONFIRM_BUTTON}
              </Button>
            </div>
          </Fragment>
        ) : (
          <Form
            className="modal-form"
            autoComplete="nope"
            validated={validated}
          >
            {UserDetailsInputList.map((item) => {
              const handleFieldChange = (event) => {
                setIsError({ [item.eventId]: "" });
                const updatedValue = event?.target?.value?.replace(
                  REGEX_VALIDATIONS.removeSpace,
                  ""
                );
                const regexPattern = REGEX_VALIDATIONS[item.regex];
                if (updatedValue === "" || !item.regex || !regexPattern || regexPattern.test(updatedValue)) {
                  handleChange(item.eventId, updatedValue);
                }
              };
              return (
                <Fragment key={item.label}>
                  <InputGroup hasValidation className="mx-1" controlId="">
                    <Form.Floating className="flex-grow-1">
                      <Form.Control
                        type={
                          showPass && item.eventId === "password"
                            ? "text"
                            : item.type
                        }
                        autoComplete="off"
                        placeholder={item.label}
                        value={item.value}
                        onChange={(e) => {
                          handleFieldChange(e);
                        }}
                        onSelect={(e) => {
                          handleFieldChange(e);
                        }}
                        required={item.isRequired}
                      />
                      <label htmlFor={item.eventId}>
                        {item.label}
                        {item.isRequired && (
                          <span style={{ color: colors.warning }}> *</span>
                        )}
                      </label>
                    </Form.Floating>

                    {item.eventId === "password" ? (
                      <InputGroup.Text
                        onClick={() => setShowPass(!showPass)}
                        style={{ cursor: "pointer" }}
                      >
                        {showPass ? <EyeHideLogo /> : <EyeOpenLogo />}
                      </InputGroup.Text>
                    ) : null}
                  </InputGroup>
                  <div className="mb-3 mx-1" style={{ color: colors.warning }}>
                    {hasError[item.eventId]}
                  </div>
                </Fragment>
              );
            })}
            <Form.Floating as={Row} className="mb-3 mx-1" controlId="">
              <Form.Control
                as="select"
                onChange={(e) => {
                  setIsError({ role: "" });
                  handleChange("role", e.target.value);
                }}
                value={role}
                required
                className="form-select"
              >
                <option value="" selected disabled hidden>
                  Select
                </option>
                {isSuperAdmin && (
                  <option value={ADMIN_TYPE.SUPER_ADMIN}>
                    {ADMIN_TYPE.SUPER_ADMIN}
                  </option>
                )}
                <option value={ADMIN_TYPE.SCHOOL_ADMIN}>
                  {ADMIN_TYPE.SCHOOL_ADMIN}
                </option>
                <option value={ADMIN_TYPE.SALES_ADMIN}>
                  {ADMIN_TYPE.SALES_ADMIN}
                </option>
              </Form.Control>
              <label htmlFor="role">
                <span>Role</span>
                <span style={{ color: colors.warning }}> *</span>
              </label>
            </Form.Floating>
            <div className="mb-3 mx-1" style={{ color: colors.warning }}>
              {hasError["role"]}
            </div>
            <div className="btnContainer">
              <Button className="create-button-btn w-100" onClick={saveDetails}>
                {CREATE_USER_CONSTANTS.SAVE_BUTTON}
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </CreateModalStyled>
  );
};

CreateUserModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleHide: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  emailAddress: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  validated: PropTypes.bool.isRequired,
};
